import Headroom from 'headroom.js';
import $ from 'jquery';
import {toggleBodyScroll} from '../base/utils';

class TopBar {
    constructor() {
        this.$win = $(window);
        this.$topBar = $('#top-bar');
        this.$body = $('body');

        this.resize();
        this.events();
    }

    events() {
        this.$body.on('font-size-change', this.resize.bind(this));

        this.$body.on('click', '.hamburger, .mega-menu-close', e => {
            e.preventDefault();
            this.$body.toggleClass('menu-open');
            toggleBodyScroll(this.$body.hasClass('menu-open'));
        });

        this.$win.scroll();
    }

    resize() {
        let offset = Math.ceil(parseFloat(this.$topBar.closest('.top-bar-wrap').css('top')));

        if (window.innerWidth >= 576) { // po obrocie zwijamy menu
            this.$body.removeClass('menu-open');
        }

        if (this.headroom) {
            this.headroom.destroy();
        }
        this.headroom = new Headroom(this.$topBar[0], {offset: offset, tolerance: 10});
        this.headroom.init();
    }
}

export default TopBar;



// WEBPACK FOOTER //
// ./sources/js/components/top-bar.js